import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import type { Section } from '@manaro/contracts'
import { homePath } from '@/shared/config/navigation.ts'
import { useSession } from './use-session.ts'

/** Sends people away from sections their access does not include; the server refuses them anyway. */
export function RequireSection({ section, children }: { section: Section; children: ReactNode }) {
  // RequireAuth above has already loaded the session, so this reads it from the cache.
  const sections = useSession().data?.user.sections ?? []
  if (!sections.includes(section)) return <Navigate to={homePath(sections)} replace />
  return children
}
